const debtor = {
	index: {
		account: {
			description: "In deze sectie bevinden zich uw accountgegevens die bij ons bekend zijn.",
			success: "Uw accountgegevens zijn nu succesvol bijgewerkt!",
			title: "Accountgegevens",
		},
		address: {
			description: "In deze sectie bevinden zich uw adresgegevens.",
			success: "Uw adresgegevens zijn nu succesvol bijgewerkt!",
			title: "Adresgegevens",
		},
		title: "Persoonlijk",
	},
	notifications: {
		description: "In deze sectie bevinden zich alle notificaties",
		table: {
			received: "Ontvangen notificatie",
			timestamp: "Ontvangen op",
		},
		title: "Notificaties",
	},
	security: {
		modal_setup: {
			description: "Volg onderstaande stappen om 2FA toe te voegen aan uw account.",
			step_1: {
				description: "Scan onderstaande QR-code met een authenticator app.",
				title: "Stap 1",
			},
			step_2: {
				description: "Bevestig de 2FA code die zich bevind in de authenticator app",
				placeholder: "6-cijferige code",
				title: "Stap 2",
			},
			success: "2FA is succesvol ingeschakeld op uw account.",
			title: "2FA instellen",
		},
		modal_unset: {
			description: "Volg onderstaande stappen om 2FA uit te schakelen voor uw account.",
			step_1: {
				description:
					"Bevestig dat u daadwerkelijk 2FA wilt uitschakelen door uw wachtwoord in te vullen.",
				placeholder: "Uw wachtwoord",
				title: "Stap 1",
			},
			step_2: {
				description: "Bevestig de 2FA code die zich bevind in de authenticator app",
				placeholder: "6-cijferige code",
				title: "Stap 2",
			},
			success: "2FA is succesvol uitgeschakeld op uw account.",
			title: "2FA uitschakelen",
			warning:
				"Let op! Door 2FA uit te schakelen maakt u het hackers eenvoudiger om toegang te krijgen tot uw account.",
		},
		section1: {
			apps: {
				description:
					"Voor 2FA gebruiken we het universele OAuth. Mogelijk hebt u al een app. Anders kunt u een van de onderstaande gebruiken.",
				title: "Authenticator apps",
			},
			description:
				"Een two factor authentication (2FA) is een authenticatie methode waarbij je twee stappen succesvol moet doorlopen om ergens toegang tot te krijgen. Rechts vind u enkele apps die u hiervoor kunt gebruiken.",
			title: "Wat is 2FA?",
		},
		section2: {
			description:
				"Wij adviseren onze gebruikers om 2FA toe te passen. Door extra verificatie toe te voegen bent is uw account beter beveiligd.",
			title: "2FA inschakelen",
		},
		status: {
			active: {
				button: "2FA uitschakelen",
				description: "Uw account is extra beveiligd met 2FA (tweestapsverificatie).",
				title: "2FA ingesteld",
			},
			inactive: {
				button: "2FA inschakelen",
				description: "Let op! U heeft nog geen 2FA (tweestapsverificatie) toegevoegd.",
				title: "2FA niet ingesteld",
			},
		},
	},
	ssh: {
		description: "Hier bevinden zich de SSH keys die gekoppeld zijn aan uw account.",
		dialog: {
			create: {
				description:
					"Voeg hier uw nieuwe public SSH-key toe. Deze wordt in uw account opgeslagen en kunt u toevoegen aan uw VPS'en.",
				external_description:
					"Voeg hier uw externe public SSH-key toe. U kunt in dit veld 1 SSH key tegelijkertijd toevoegen.",
				external_title: "Externe SSH-key toevoegen",
				form: {
					description: {
						label: "Beschrijving",
						placeholder: "Geef uw SSH-key een omschrijving.",
					},
					public_key: {
						label: "Public SSH-key",
						placeholder: "Vul uw unieke SSH-key in.",
					},
					type: {
						label: "Type",
						placeholder: "Geef uw SSH-key een type",
					},
				},
				status: {
					success: "SSH-key is toegevoegd!",
					unknown:
						"Er kan op dit moment geen SSH-key worden toegevoegd. Probeert u het later opnieuw.",
				},
				title: "SSH-key toevoegen",
			},
			delete: {
				description:
					"Wilt u de SSH-key met de beschrijving <strong>{{description}}</strong> verwijderen?",
				status: {
					success: "SSH-key is verwijderd!",
					unknown:
						"Op dit moment kan de SSH-key niet worden verwijderd. Probeert u het later opnieuw.",
				},
				title: "Verwijder SSH-key",
			},
			edit: {
				description: "Bewerk hier uw toegevoegde public SSH-key.",
				external_description: "Bewerk hier uw toegevoegde externe public SSH-key.",
				external_title: "Externe SSH-key bewerken",
				form: {
					description: {
						label: "Beschrijving",
						placeholder: "Geef uw SSH-key een omschrijving.",
					},
					public_key: {
						label: "Public SSH-key",
						placeholder: "Vul uw unieke SSH-key in.",
					},
					type: {
						label: "Type",
						placeholder: "Geef uw SSH-key een type",
					},
				},
				title: "SSH-key bewerken",
			},
		},
		invalid:
			"Ingevoerde SSH-key is niet een valide publieke SSH-key. Controleer of de SSH-key correct ingevoerd is.\n Als u er zeker van bent dat de publieke SSH-key correct is, neem contact op met support.",
		item: {
			description: "Beschrijving",
			description_missing: "Geen beschrijving in SSH key",
			ssh_key: "Public SSH-key",
			type: "Type",
		},
		title: "SSH-keys",
	},
	tabs: {
		connections: "Connected apps",
		debtor_information: "Accountgegevens",
		log: "Activiteiten log",
		notifications: "Notificaties",
		security: "Veiligheid (2FA)",
		ssh_keys: "SSH-keys",
		update_information: "Login gegevens",
	},
	update_login_info: {
		password: {
			description: "In deze sectie kunt u uw huidige wachtwoord wijzigen.",
			success: "Uw wachtwoord is nu succesvol bijgewerkt!",
			title: "Wachtwoord wijzigen",
		},
		username: {
			description:
				"In deze sectie kunt u uw gebruikersnaam wijzigen. <br/><br/><i><strong>Let op:</strong> voor het wijzigen van uw gebruikersnaam moet u uw huidige wachtwoord invullen.</i>",
			success: "Uw gebruikersnaam is nu succesvol bijgewerkt!",
			title: "Gebruikersnaam wijzigen",
		},
	},
};

export default debtor;
